export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-16">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
      <p className="mb-4">
        Optiwizer Technologies ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our website and services.
      </p>
      <h2 className="text-xl font-semibold mt-8 mb-2">Information We Collect</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Personal Information: Name, email address, phone number, company name, and other details you provide via forms.</li>
        <li>Usage Data: Pages visited, time spent, browser/device info, and IP address (via analytics tools).</li>
        <li>Cookies: We use cookies and similar technologies for analytics and site functionality.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-8 mb-2">How We Use Your Information</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>To respond to your inquiries and provide our services.</li>
        <li>To improve our website, services, and user experience.</li>
        <li>To send you updates, newsletters, or marketing (you can opt out at any time).</li>
        <li>To comply with legal obligations.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-8 mb-2">Data Sharing</h2>
      <p className="mb-4">
        We do not sell or rent your personal information. We may share data with trusted service providers (e.g., analytics, CRM) who help us operate our business, but only as necessary and with appropriate safeguards.
      </p>
      <h2 className="text-xl font-semibold mt-8 mb-2">Your Rights</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Access, correct, or delete your personal information by contacting us.</li>
        <li>Opt out of marketing communications at any time.</li>
        <li>Disable cookies in your browser settings (may affect site functionality).</li>
      </ul>
      <h2 className="text-xl font-semibold mt-8 mb-2">Security</h2>
      <p className="mb-4">
        We use reasonable technical and organizational measures to protect your data. However, no method of transmission over the Internet is 100% secure.
      </p>
      <h2 className="text-xl font-semibold mt-8 mb-2">Contact Us</h2>
      <p className="mb-4">
        If you have any questions about this Privacy Policy or your data, please contact us at <a href="mailto:info@optiwizer.com" className="text-blue-600 underline">info@optiwizer.com</a>.
      </p>
    </div>
  );
} 